import React, { useState ,useEffect ,useMemo } from "react";
import ticketicon from  "../../../../../../../Assets/AppComponent/Customersupport_icon/ticketicon.svg"
import arroicon from  "../../../../../../../Assets/AppComponent/Customersupport_icon/DetailArrow.svg"
import searchicon from "../../../../../../../Assets/AppComponent/Customersupport_icon/Searchicon.svg"
import {clearCategoryList_State} from "../../../../../../../Redux/Slice"
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import boximg from "../../../../../../../Assets/AppComponent/Group 427320177.svg";


export default function AllIssueCategoryList({
    datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range

}) {
  const [search, setSearch] = useState("");


const dispatch = useDispatch();
const state = useSelector((state)=>state)
 const dashboardData = useSelector((state) => state.IssueCategoryListedCustom.CategoryListData);
let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");




     useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){

         const payload ={
    state:datas?.state,
    region:datas?.region,
    zone:datas?.zone,
     priority:PriorityValues,
     client:Client,
     search:search,
       from_date: range[0],
      to_date: range[1],
      range: isValidRange,
              date:date,
            
         }
         dispatch(clearCategoryList_State(payload))
    }

    },[datas  ,Client  ,PriorityValues,search, date ])

    const IssueListed = dashboardData.map((issue, index) => ({
  id: issue?.clientsub_category_id__issue_category__id,
  name: issue.clientsub_category_id__issue_category__name,
  count: issue.group_tickets,
}));

  function tochange(value) {
  debouncedSearch(value);  // call debounced search
}

const debouncedSearch = useMemo(
  () =>
    _.debounce((val) => {
      setSearch(val);     // set actual search state after 500ms
    }, 500),
  []
);

// Cancel debounce on unmount
useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };

}, [debouncedSearch]);
function capitalizeEachWord(text) {
  if (!text || typeof text !== "string" || text.trim() === "") {
    return "--";
  }
  
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}



  return (
    
    <div className="all-issue-category-list">
    <div className="HeaderOfList">
          <h6 style={{ fontSize: 16,  }}>All Issue Category</h6>

    <div className="search-container">
  <span className="search-icon">
    <img src={searchicon} alt="search" />
  </span>
  <input
    type="text"
  onChange={(e) => tochange(e.target.value)}
    placeholder="Search..."
    className="search-input"
  />
</div>

    </div>
      <div className="Recordslisted">
{IssueListed.length > 0 ? (
  IssueListed.map((issue) => (
    <div key={issue.id} className="issue-card">
      <div className="issue-left">
        <div className="Innner_iocn">
          <div className="icon-box">
            <img src={ticketicon} alt="ticket icon" />
          </div>
        </div>
        <div className="issue-text">
                    <div className="name">{capitalizeEachWord(issue.name)}</div>
          <div className="count">{issue.count} Tickets</div>
        </div>
      </div>
      {/* <div className="Details_icons">
        <img src={arroicon} className="arrow" />
      </div> */}
    </div>
  ))
) : (
  <div className="Dusbinbacktabls">
    <div>
      <img src={boximg} alt="no data" />
      <p className="text-center">No Data Available</p>
    </div>
  </div>
)}


      </div>
    </div>
  );
}
